<template>
  <div class="whole-wrapper">
    <h3
      class="hd pf-medium"
      :class="{ ph: ph }"
      style="margin-bottom: -0.16rem"
    >
      <template v-if="personType == 1">
        取票人
        <span class="num-tips red">需要{{ num }}位</span>
        <span class="num-tips gray">，用于取票身份验证</span>
      </template>
      <template v-else>
        游客信息
        <span class="num-tips red">需要{{ num }}位</span>
        <span class="num-tips gray">，用于入园身份验证</span>
      </template>
    </h3>
    <div class="bd" :class="cls">
      <div class="content-wrapper">
        <div class="persons-herizon-selector" v-if="listHorizonAll.length > 0">
          <div class="persons-herizon">
            <div
              class="cell cdlr"
              v-for="(item, index) in listHorizonAll"
              :key="index"
              :class="{
                checked: item.isChecked,
                disabled: false
              }"
              @click="toggleCheck(item, index)"
            >
              {{ item.checked }}
              <span class="person-cell">{{ item.name }}</span>
            </div>
          </div>
          <div class="more" @click="showPopup">
            <span class="l">
              新增
              <br />更换
            </span>
            <i class="r iconfont icon-arrow-right"></i>
          </div>
        </div>
        <div class="cell-person-select pr">
          <div class="devider"></div>
          <ul class="person-wrap" v-if="listVertical.length">
            <li v-for="(item, index) in listVertical" :key="index">
              <div class="person-info-above">
                <div class="person-index-wrap">
                  <div class="person-index">
                    <div class="index-label">
                      {{ personType === 1 ? '取票人' : '游客' }}
                      <span v-if="listVertical.length > 1">
                        {{ index + 1 }}
                      </span>
                    </div>
                    <img
                      v-if="item.name"
                      class="btn_remove"
                      @click="cancelChecked(item)"
                      src="~@/assets/images/order/icon_close_travel_person@3x.png"
                    />
                  </div>
                </div>
                <div class="person-item" v-if="item.name">
                  <div class="name-row">
                    <span class="start_label">{{ item.name }}</span>
                    <span>{{ item.mobile | maskMobile }}</span>
                  </div>
                  <div class="card-row">
                    <span class="start_label" v-if="item.card">身份证</span>
                    <span>{{ item.card | maskCard }}</span>
                  </div>
                </div>
                <div class="btn-edit" v-if="item.name" @click="modify(item)">
                  编辑
                </div>
                <div class="btn-add" v-else @click="completeCheckedNull(index)">
                  点击补全游客信息
                </div>
              </div>
              <div class="person-info-below" v-if="item.ageMatch === 0">
                <img
                  class="icon_warn"
                  src="~@/assets/images/order/icon-tip-red2@3x.png"
                />
                <span class="warn-text">不符合适用人群年龄限制</span>
              </div>
            </li>
          </ul>

          <vant-popup
            class="popup"
            v-model="isShowPopup"
            round
            position="bottom"
            :style="{ height: '60%' }"
            closeable
            @close="hidePopup"
          >
            <div class="title pf-medium">选择游客</div>
            <div class="bd">
              <person-index
                v-if="isInitialized"
                :isPopup="true"
                @unshiftPerson="unshiftPersonWithoutChecked"
                @modify="modify"
                @removed="onRemoved"
                @usePersonList="usePersonList"
                :numIn="num"
                :tpidsIn="tpids"
                :allList="listHorizonAll"
              ></person-index>
            </div>
          </vant-popup>

          <vant-popup
            class="popup"
            v-model="isShowEditPopup"
            round
            position="bottom"
            :style="{ height: '60%' }"
            closeable
            @close="hideEditPopup"
          >
            <div class="title pf-medium">编辑游客</div>
            <div class="bd">
              <person-edit
                :isPopup="true"
                v-if="isEditInitialized"
                :person="editingPerson"
                @back="onEditBack"
                @editSuccess="onEditSuccess"
                @removed="onRemoved"
              ></person-edit>
            </div>
          </vant-popup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popup } from 'mint-ui'
import { Popup as VantPopup } from 'vant'
// import top from 'components/common/top'
import top from './top'
import personIndex from './person/index'
import personEdit from './person-edit/index.vue'
import http from '@/plugins/http'
import { createNamespacedHelpers } from 'vuex'
const { mapMutations: mapMutationNs, mapActions } =
  createNamespacedHelpers('insurance')
import { List } from 'vant'
import { cloneDeep } from 'lodash'
import bus from '@/Bus/travel-person'

export default {
  components: {
    Popup,
    VantPopup,
    top,
    personIndex,
    personEdit
  },
  data() {
    return {
      skuId: '',
      isShowPopup: false,
      isInitialized: false,
      isEditInitialized: false,
      listHorizonAll: [],
      isShowEditPopup: false,
      editingPerson: {}
    }
  },
  props: {
    personType: {
      type: Number,
      default: 0 // 0：出行人；1:取票人
    },
    ph: {
      type: Boolean,
      default: false
    },
    supportInsurance: {
      type: Boolean,
      default: false
    },
    pr: {
      type: Boolean,
      default: false
    },
    num: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    listHorizonChecked() {
      let listChecked = this.listHorizonAll.filter(item => item.isChecked)
      if (this.num < listChecked.length) {
        let checkedCount = 0
        this.listHorizonAll.forEach(item => {
          if (item.isChecked) {
            checkedCount++
          }
          if (checkedCount > this.num) {
            item.isChecked = false
          }
        })
      }
      let lisChecked = this.listHorizonAll.filter(item => item.isChecked)
      this.$emit('input', lisChecked)
      return lisChecked
    },
    listVertical() {
      let diff = this.num - this.listHorizonChecked.length
      if (diff > 0) {
        let list = [...this.listHorizonChecked]
        console.log(JSON.stringify(list))
        for (let i = 0; i < diff; i++) {
          list.push({})
        }
        return list
      } else {
        return this.listHorizonChecked
      }
    },
    list() {
      return this.value
    },
    validateNum() {
      // 验证游客人数
      const n = parseInt(this.num, 10)
      if (isNaN(n)) {
        return 0
      } else {
        return n
      }
    },
    tpids() {
      return this.list.map(item => item.tpid)
    },
    cls() {
      return {
        ph: this.ph,
        pr: this.pr
      }
    }
  },
  watch: {
    num(nowValue, oldValue) {
      let length = this.listHorizonAll.length
      let listChecked = this.listHorizonAll.filter(item => item.isChecked)
      let lengthChecked = listChecked.length
      if (nowValue > lengthChecked) {
        let diff = nowValue - lengthChecked
        let i = 0
        let j = 0
        while (i < length) {
          let item = this.listHorizonAll[i]
          if (!item.isChecked) {
            item.isChecked = true
            j++
          }
          i++
          if (j === diff) break
        }
      }
    }
  },
  created() {},
  async mounted() {
    console.log('人数约束', this.num)
    this.skuId = this.$route.query.skuId || ''
    await this.fetchAllPerson()
    bus.editCallback(item => {
      this.editSuccess(item, true)
    })
    bus.rmCallback(tpid => {
      this.remove(tpid, true)
    })
  },
  methods: {
    ...mapActions(['getTravelPersonList']),
    ...mapMutationNs(['setTravelPersonList']),
    async fetchAllPerson() {
      const { uid, skey } = await this.$$ensureLogin()
      if (!uid || !skey) return 1
      const param = {
        uid,
        skey,
        startPage: 0,
        pageSize: 100,
        giveInsure: this.supportInsurance ? 1 : 0
      }
      if (this.personType === 0) {
        param.skuId = this.skuId
      }
      const qs = this.$$queryString.stringify(param)
      const url = `//soperationapi.cekid.com/soperation-api/traveling/travelingPersonList.do?${qs}`
      http.get(url).then(res => {
        if (res.errno === 505) {
          this.$$login()
        } else if (res.errno !== 0) {
          this.$$toast(res.errmsg)
        } else {
          const list = res.data.map(item => {
            item.isChecked = false
            return item
          })

          this.reportDataChange(list)
          this.listHorizonAll = list

          let length = this.listHorizonAll.length
          if (this.num > 0 && length > 0) {
            for (let i = 0; i < Math.min(this.num, length); i++) {
              let item = this.listHorizonAll[i]
              item.isChecked = true
            }
          }
        }
      })
    },
    restorePerson() {
      const json = sessionStorage.getItem('my/person.listChecked')
      if (json) {
        const listChecked = JSON.parse(json)
        this.listHorizonAll.forEach(item => {
          listChecked.forEach(item2 => {
            if (item.tpid == item2.tpid) {
              item.isChecked = true
            }
          })
        })
        console.log(
          'travPersonList restored: ',
          JSON.stringify(this.listHorizonAll)
        )
      }
    },
    showPopup() {
      this.isShowPopup = true
      this.isInitialized = true
      this.listHorizonAll = cloneDeep(this.listHorizonAll)
    },
    hidePopup() {
      this.isShowPopup = false
      this.isInitialized = false
    },
    usePersonList(listAll, listChecked) {
      this.listHorizonAll = listAll
      this.$emit('input', listChecked)
      this.hidePopup()
    },
    showEditPopup() {
      this.isShowEditPopup = true
      this.isEditInitialized = true
    },
    hideEditPopup() {
      this.isShowEditPopup = false
      this.isEditInitialized = false
    },
    onEditBack() {
      this.hideEditPopup()
    },
    modify(item) {
      this.editingPerson = { ...item }
      this.showEditPopup()
    },
    completeCheckedNull(index) {
      this.editingPerson = { index, isChecked: true }
      this.showEditPopup()
    },
    unshiftPersonWithoutChecked() {
      this.editingPerson = { index: -1, isChecked: false }
      this.showEditPopup()
    },
    onEditSuccess(item) {
      this.editSuccess(item, false)
    },
    editSuccess(item, fromEventBus) {
      let exist = this.listHorizonAll.some(
        otherItem => otherItem.tpid == item.tpid
      )
      if (exist) {
        this.listHorizonAll = this.listHorizonAll.map(otherItem => {
          if (otherItem.tpid == item.tpid) {
            otherItem.name = item.name
            otherItem.mobile = item.mobile
            otherItem.card = item.card
          }
          return otherItem
        })
      } else if (item.index == -1) {
        this.listHorizonAll.unshift(item)
      } else {
        this.listHorizonAll.push(item)
      }
      if (!fromEventBus) {
        // this.reportDataChange(this.listHorizonAll)
        this.hideEditPopup()
        //修改后 如果送保险得重新请求出行人列表
        if (this.supportInsurance) {
          this.getTravelPersonList({ vm: this, isCommit: true })
        }
      }
    },
    onRemoved(tpid) {
      this.remove(tpid, false)
    },
    remove(tpid, fromEventBus) {
      let index = -1
      for (let i = 0; i < this.listHorizonAll.length; i++) {
        if (this.listHorizonAll[i].tpid == tpid) {
          index = i
          break
        }
      }
      if (index > -1) {
        this.listHorizonAll.splice(index, 1)
      }
      if (!fromEventBus) {
        this.reportDataChange(this.listHorizonAll)
        this.hideEditPopup()
      }
    },
    cancelChecked(item) {
      item.isChecked = !item.isChecked
    },
    toggleCheck(item, index) {
      if (this.num === 1 && !item.isChecked) {
        item.isChecked = true
        this.listHorizonAll.forEach(otherItem => {
          if (otherItem.tpid != item.tpid) {
            otherItem.isChecked = false
          }
        })
        this.$emit('input', this.listHorizonChecked)
        return
      }
      let diff = this.num - this.listHorizonChecked.length
      if (diff > 0 || item.isChecked) {
        item.isChecked = !item.isChecked
        // this.$set(this.listHorizonAll, index, item)
        this.$emit('input', this.listHorizonChecked)
      } else {
        this.$$toast(`您已选满${this.num}位.请先点消一位,再来点选`)
      }
    },
    //深拷贝一下数据 供保险使用
    reportDataChange(list) {
      this.setTravelPersonList(
        list.map(x => {
          return {
            ...x
          }
        })
      )
    }
  },
  filters: {
    maskMobile(str) {
      return `${str.substr(0, 3)}****${str.substr(-4)}`
    },
    maskCard(str) {
      return `${str.substr(0, 4)}**********${str.substr(-4)}`
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.whole-wrapper {
  background-color: #fff;
  border-radius: rem(16px);
  padding-bottom: rem(10px);
  margin-bottom: rem(20px);
  .hd {
    height: rem(88px);
    background-color: #fff;
    border-radius: rem(16px);
    line-height: rem(88px);
    font-size: rem(30px);
    color: #262626;
    font-weight: 500;
    &.ph {
      padding: 0 rem(24px);
    }

    .num-tips {
      height: rem(32px);
      font-size: rem(22px);
      color: #ff5900;
      line-height: rem(32px);
      &.red {
        color: #ff5900;
      }

      &.gray {
        color: #666;
      }
    }
  }
  .bd {
    &.ph {
      padding-left: rem(24px);
    }
    &.mt {
      margin-top: rem(20px);
    }
    &.mb {
      margin-bottom: rem(20px);
    }
    &.rd {
      border-radius: rem(6px);
      overflow: hidden;
    }
    &.bg {
      background-color: #fff;
      border-radius: rem(16px);
      margin-bottom: rem(20px);
    }

    .devider {
      width: 100%;
      height: rem(1px);
      background: #eeeeee;
    }

    .content-wrapper {
      .persons-herizon-selector {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        .persons-herizon {
          display: flex;
          padding: rem(20px) 0;
          flex-direction: row;
          // overflow: auto;
          overflow-x: scroll;
          white-space: nowrap;
          &::-webkit-scrollbar {
            display: none;
          }
          .cell {
            display: flex;
            margin-right: rem(16px);
            border: rem(3px) solid #e7e7e7;
            border-radius: rem(8px);
            overflow: hidden;
            padding: rem(5px);
            &.cdlr {
              width: rem(164px);
              height: rem(80px);
              flex: 0 0 rem(164px);
              background-color: #fff;
              flex-direction: column;
              justify-content: center;
              .person-cell {
                text-align: center;
                font-size: rem(26px);
                margin-bottom: rem(4px);
                color: #121212;
                padding-right: rem(6px);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .prc {
                color: #ff4b4b;
                font-size: rem(32px);
                margin-bottom: rem(2px);
                small {
                  font-size: rem(24px);
                  margin-right: rem(4px);
                }
                b {
                  font-weight: normal;
                }
              }
              &.disabled {
                background-color: #e7e7e7;
                .date,
                .noavl {
                  color: #262626;
                  font-size: rem(26px);
                }
              }
              &.checked {
                position: relative;
                border: 1px solid #ff5900;
                background-color: #fff5f0;
                &::after {
                  content: '';
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  width: rem(29px);
                  height: rem(26px);
                  margin-right: -1px;
                  margin-bottom: -1px;
                  background-image: url('~@/assets/images/order/date_check.png');
                  background-size: contain;
                }
              }
            }
          }
        }
        .more {
          display: flex;
          margin-right: rem(16px);
          border: rem(3px) solid #e7e7e7;
          border-radius: rem(16px);
          overflow: hidden;
          width: rem(114px);
          height: rem(80px);
          flex: 0 0 rem(114px);
          display: flex;
          justify-content: center;
          align-items: center;
          .l {
            font-size: rem(24px);
            color: #121212;
            line-height: rem(36px);
            margin: 0 rem(6px);
          }
          .r {
            font-size: rem(22px);
          }
        }
      }
      .cell-person-select {
        &.ph {
          padding: 0 rem(20px);
        }
        &.pr {
          padding-right: rem(20px);
        }
      }
      .travel-person {
        overflow: hidden;
        height: rem(100px);
        background: #fff;
        color: #666666;
        line-height: rem(100px);
        text-align: center;
        span {
          font-size: rem(30px);
        }
        small {
          font-size: rem(26px);
        }
        .btn {
          /*float: right;*/
          /*padding: rem(27px) rem(24px);*/
          /*margin-right: rem(-24px);*/
          line-height: 1;
          i {
            color: #666666;
          }
        }
      }

      .person-wrap {
        background: #fff;
        li {
          // @include border(bottom, #dddddd);
          border-bottom: solid rem(1px) #ddd;
          // height: rem(124px);
          display: flex;
          flex-direction: column;

          &:last-child {
            border-bottom: none;
          }

          .person-info-above {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            justify-items: center;
            align-items: center;
            padding: rem(24px) 0 rem(12px) 0;

            .person-index-wrap {
              text-align: left;
              margin-right: rem(30px);

              .person-index {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-left: rem(-10px);
                width: rem(100px);
                .index-label {
                  font-size: rem(26px);
                  color: #666666;
                  line-height: rem(32px);
                }
                .btn_remove {
                  width: rem(32px);
                  height: rem(32px);
                  margin-top: rem(10px);
                }
              }
            }

            .person-item {
              font-size: rem(26px);
              color: #262626;
              line-height: rem(32px);
              width: 100%;
              .name-row {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                .start_label {
                  width: 20%;
                  display: inline-block;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
              .card-row {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                margin-top: rem(12px);
                .start_label {
                  width: 20%;
                  display: inline-block;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }

            .btn-edit {
              display: block;
              font-size: rem(26px);
              color: #348be6;
              height: rem(80px);
              width: rem(80px);
              text-align: center;
              line-height: rem(80px);
            }

            .btn-add {
              display: block;
              font-size: rem(26px);
              color: #348be6;
              height: rem(80px);
              text-align: center;
              line-height: rem(80px);
            }
          }

          .person-info-below {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            padding-bottom: rem(24px);

            .icon_warn {
              width: rem(24px);
              height: rem(24px);
              margin-left: rem(120px);
              margin-right: rem(8px);
            }
            .warn-text {
              height: rem(28px);
              font-size: rem(22px);
              color: #ff2f25;
              line-height: rem(28px);
            }
          }
        }
      }
      .person-row {
        height: rem(100px);
        overflow: hidden;
        padding-top: rem(36px);
        // @include border(top, #DDDDDD);
        i {
          padding: 0 rem(14px);
          height: rem(36px);
          line-height: rem(36px);
          font-size: rem(22px);
          color: #fff;
          text-align: center;
          border-radius: rem(18px);
          margin-right: rem(24px);
          background: #ff7d46;
        }
        strong {
          font-size: rem(26px);
          color: #666666;
          font-weight: normal;
        }
        span {
          float: right;
          margin-right: rem(24px);
        }
      }
      .popup {
        width: 100%;
        height: 100%;
        z-index: 999;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        .bd {
          position: relative;
          flex: 1;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          overflow-scrolling: touch;
        }
      }

      .title {
        margin: 0 rem(26px);
        height: rem(108px);
        @include ellicpsis;
        font-size: rem(32px);
        color: #121212;
        letter-spacing: 0;
        line-height: rem(108px);
        border-bottom: #ededed 1px solid;
      }
    }
  }
}
</style>
